<template>
  <div class="alert-wrapper" :class="{'notification-element': showBox && inlineLayout}">
    <div class="txt-before-alert" v-if="!showBox && inlineLayout">
      <slot name="beforeAlert"></slot>
    </div>
    <div v-if="showBox && !inlineLayout" class="card-wrapper notification-card" id="emailAlert">
        <div class="card email-not-verified">
          <div class="text">
            <slot name="emailAlertHeadline"></slot>
            <div v-if="this.confirmationMailRequested" class="info" v-html="getRequestWaitInfoText"></div>
          </div>
          <button class="filled white" :disabled="this.confirmationMailRequested" @click="sendVerificationEmail"><slot name="emailAlertButton"></slot></button>
        </div>
    </div>
    <div v-if="showBox && inlineLayout" class="inline-layout-alert-wrapper">
      <div class="upper-container">
        <div class="label-row">
          <div class="label-container">
            <span class="txt-before-alert with-alert"><slot name="beforeAlert"></slot></span>
            <span class="alert-headline pre-request" v-if="!confirmationMailRequested"><slot name="emailAlertHeadlineBeforeRequest"></slot></span>
            <span class="alert-headline post-request" v-if="confirmationMailRequested"><slot name="emailAlertHeadlineAfterRequest"></slot></span>
          </div>
          <div class="side-btn">
            <button class="text" :disabled="confirmationMailRequested" @click="sendVerificationEmail"><slot name="emailAlertButton"></slot></button>
          </div>
        </div>
        <div class="info-row">
          <div v-if="confirmationMailRequested" class="info" v-html="getRequestWaitInfoText"></div>
        </div>
      </div>
      <div class="bottom-btn">
        <button :class="buttonClass" :disabled="confirmationMailRequested" @click="sendVerificationEmail"><slot name="emailAlertButton"></slot></button>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { mapGetters, mapMutations } from 'vuex'
import { splitError } from '@/helper/splitError'
import { wrapQuery } from '@/helper/wrapGQLQuery'

export default {
  name: 'EMailConfirmationMissing',
  mixins: [
  ],
  data () {
    return {
      loadedCurrentCustomer: false,
      loading: false,
      verificationMailSent: false,
      currentCustomer: {
        alternativePhone: '',
        email: '',
        emailVerified: false
      }
    }
  },
  props: {
    showWhenRequested: {
      type: Boolean,
      default: true
    },
    inlineLayout: {
      type: Boolean,
      default: false
    },
    contractState: {
      type: Object,
      default: () => {}
    },
    buttonClass: {
      type: String,
      default: 'text'
    }
  },
  watch: {
    showBox: {
      immediate: true,
      handler: function (newValue) {
        this.$emit('update:showBox', newValue)
      }
    }
  },
  computed: {
    showBox: function () {
      let show = false

      if (this.loadedCurrentCustomer && this.currentCustomer.email) {
        if (!this.currentCustomer.emailVerified && !this.contractState?.contractTerminated) {
          show = (!this.confirmationMailRequested || this.showWhenRequested)
        }
      }

      return show
    },
    confirmationMailRequested: function () {
      return !!this.confirmationMailRequestedDateTime() && this.confirmationMailCountdownMin > 0
    },
    confirmationMailCountdownMin: function () {
      if (this.confirmationMailRequestedDateTime()) {
        const dt = new Date().getTime() / 1000
        return (10 - parseInt(Math.abs(dt - this.confirmationMailRequestedDateTime()) / 60))
      }

      return null
    },
    getRequestWaitInfoText () {
      let t = this.$slots.txtInfoConfirmationMailRequested && this.$slots.txtInfoConfirmationMailRequested[0].text ? this.$slots.txtInfoConfirmationMailRequested[0].text.replace('10', this.confirmationMailCountdownMin) : ''
      if (this.confirmationMailCountdownMin === 1) {
        t = t.replace('Minuten', 'Minute')
      }
      return t
    }
  },
  methods: {
    ...mapMutations('emailConfirmation', [
      'setRequested'
    ]),
    ...mapGetters('emailConfirmation', {
      confirmationMailRequestedDateTime: 'requested'
    }),
    sendVerificationEmail: function () {
      const me = this
      const graphQlClient = me.$apolloProvider.defaultClient

      graphQlClient.mutate({
        mutation: gql`mutation sendVerificationEmail {
            sendVerificationEmail
        }`
      }).then((response) => {
        me.$store.commit('Transaction/removeTransactionId', 'sendVerificationEmail', { root: true })
        if (response.data.sendVerificationEmail === true) {
          this.successToast(this.$slots.txtToastConfirmationMailRequested ? this.$slots.txtToastConfirmationMailRequested[0].text : 'Sie erhalten an die eingegebene E-Mailadresse eine E-Mail mit einem Bestätigungslink.')
          this.setRequested(parseInt(new Date().getTime() / 1000))
          if (me.successMessage) {
            me.$store.commit('addMessage', { type: 'success', message: 'Sie erhalten an die eingegebene E-Mailadresse eine E-Mail mit einem Bestätigungslink.' })
          }
        } else {
          me.$store.commit('addError', 'Die EMail konnte nicht versendet werden')
          const data = {
            type: 'technical',
            message: 'Die EMail konnte nicht versendet werden'
          }
          if (typeof window.trackingNS?.track?.tracking === 'function') {
            window.trackingNS.track.tracking('error', data)
          }
        }
      }).catch((error) => {
        splitError(error).forEach(e => me.$store.commit('addError', e))
      })
    },
    refreshStatus: function () {
      this.$apollo.queries.currentCustomer.refetch()
    }
  },
  apollo: {
    currentCustomer: function () {
      return wrapQuery(
        gql`query personalData{
          currentCustomer {
            email,
            emailVerified
          }
        }`, this, 'currentCustomer', {}, () => {
          this.loadedCurrentCustomer = true
        },
        {},
        (error) => {
          if (typeof error.message !== 'undefined') {
            const data = {
              type: 'technical',
              message: error.message
            }
            if (typeof window.trackingNS?.track?.tracking === 'function') {
              window.trackingNS.track.tracking('error', data)
            }
          }
        }
      )
    }
  }
}
</script>
